import {
    Chip,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import ModalWrap from 'components/Modals/ModalWrap';
import * as API from 'services/api';
import {
    ConversationMessages,
    ConversationForm
} from './components';
import { useDispatch, } from 'react-redux';
import { setLoading } from 'redux/actions/app';
import { LEAD_TYPES } from 'config';
import PropTypes from 'prop-types';

const LocationDetails = ({ formatMessage, requestId, open, handleClose }) => {
    const dispatch = useDispatch();
    const [messages, setMessages] = useState([])
    useEffect(() => {
        if (open && requestId) {
            loadMessages()
        }
    }, [open])
    const loadMessages = () => {
        setMessages([])
        dispatch(setLoading(true));
        API.listMessages({ requestId: requestId.id }).then(res => {
            dispatch(setLoading(false));
            if (res.code == 200) {
                setMessages(res.data.reverse())
            }
        })
    }

    let title = formatMessage({ id: "leads.messages" });
    if (requestId?.type == LEAD_TYPES[4]) {
        title = requestId?.source?.title;
    }
    return (
        <ModalWrap
            title={title}
            open={open}
            closeModal={handleClose}
        >
            <ConversationMessages messages={messages} />
            <ConversationForm requestId={requestId} loadMessages={loadMessages} />
        </ModalWrap>
    );
};

LocationDetails.propTypes = {
    formatMessage: PropTypes.func,
    requestId: PropTypes.bool,
    open: PropTypes.bool,
    handleClose: PropTypes.func
};

export default LocationDetails;
